/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_completed = () => `완료됨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_endingText = () => `완료`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_inProgress_startingText = () => `진행 중`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_registered = () => `등록됨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_courseStatus_viewed = () => `조회함`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_bestPractices = () => `모범 사례`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_collection = () => `인증서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_course = () => `교육 코스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_lesson = () => `레슨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_metaDesc = () => `Klaviyo를 통해 비즈니스를 키우는 방법을 알아보세요. Klaviyo를 통한 성공에 도움이 되는 교육 과정, 인증 및 가이드를 시작하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_opengraphSiteName = () => `Klaviyo 아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_search = () => `검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_globalHead_title = () => `Klaviyo 아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_href = () => `/ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_button_label = () => `아카데미로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_404_titleText = () => `찾을 수 없음 | Klaviyo 아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_href = () => `/ko-kr/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_button_label = () => `모든 리소스 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_headline = () => `Klaviyo 아카데미로 파워 업`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_hero_subhead = () => `수익을 극대화하고 비즈니스 목표를 달성하는 데 필요한 전략과 모범 사례를 알아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_headline = () => `학습 방법을 결정하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_href = () => `/ko-kr/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_buttons_label = () => `시작 가이드 모두 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_content = () => `<p>단계별 가이드에 따라 새로운 채널, 기능 및 제품을 시작하고 실행하세요.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row1_title = () => `시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_href = () => `/ko-kr/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_buttons_label = () => `모범 사례 모두 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_content = () => `<p>최고의 전략으로 비즈니스를 성장시키고 마케팅을 최적화하세요.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row2_title = () => `모범 사례`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_href = () => `/ko-kr/search?select=Quick+guide|Under+10+minutes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_buttons_label = () => `빠른 가이드 모두 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_content = () => `<p>한 페이지로 구성된 편리한 가이드를 통해 10분 이내에 답을 찾을 수 있습니다.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row3_title = () => `빠른 가이드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_buttons_label = () => `모든 라이브 교육 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_content = () => `<p>Klaviyo 전문가와 함께하는 라이브 세션에 참석하여 실시간으로 질문에 대한 답변을 받아보세요.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row4_title = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_href = () => `/ko-kr/search?select=Course`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_buttons_label = () => `모든 교육 코스 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_content = () => `<p>온디맨드 학습 콘텐츠와 실제 사례를 통해 마케팅 전략을 비즈니스에 효과적으로 적용하는 방법을 알아보세요.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row5_title = () => `교육 코스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_href = () => `/ko-kr/search?select=Certificate`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_buttons_label = () => `모든 인증서 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_content = () => `<p>일련의 교육 코스를 통해 주제에 대해 더 깊이 알아보세요. 최종 시험을 통해 지식을 테스트하고 인증서를 받으세요.</p>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_row6_title = () => `인증서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_learn_subhead = () => `일정과 학습 스타일에 맞춰 다양한 옵션 중에서 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_button_label = () => `모든 라이브 교육 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_subhead = () => `전문가 팀으로부터 실시간으로 배움을 얻으세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_title = () => `라이브 교육 세션에 등록하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_description = () => `업계별로 우수한 이메일 전송 가능성 관련 메트릭을 살펴보고, 이메일 수행 능력을 개선하려면 어떤 전략을 사용해야 하는지 알아봅니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_href = () => `https://www.bigmarker.com/klaviyo-customer-education/strategy-session-understand-email-deliverability`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_pill = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training1_title = () => `이메일 전송 가능성 이해하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_description = () => `트래픽과 전환을 유도하는 데 도움이 되는 디자인 원칙을 알아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-Design-emails-that-convert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_pill = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training2_title = () => `전환을 유도하는 이메일 디자인하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_description = () => `채널로서의 SMS 가치와 이를 작업 흐름에 통합하는 방법을 이해합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Strategy-session-SMS-marketing-strategy-North-America`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_pill = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training3_title = () => `SMS 마케팅 전략`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_description = () => `Klaviyo 전문가에게 실시간으로 전략적인 질문을 하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_href = () => `https://www.bigmarker.com/klaviyo-customer-education/Office-hours-Getting-started-with-Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_pill = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_liveTraining_training4_title = () => `업무 시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_href = () => `/ko-kr/best-practices`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_button_label = () => `모범 사례 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_excerpt = () => `고객사 확보, 참여 유도 자동화, 매출 증대에 도움이 되는 최고의 마케팅 전략에 대해 알아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_first_title = () => `모범 사례 가이드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_href = () => `https://www.youtube.com/channel/UCLLurTBYufj95_5zTnJISnA`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_button_label = () => `YouTube 라이브러리 방문`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_excerpt = () => `동영상 튜토리얼을 통해 Klaviyo를 통한 비즈니스 성장에 도움이 되는 빠른 팁과 전문가 인사이트를 확인하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_second_title = () => `YouTube에서의 Klaviyo`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_href = () => `/ko-kr/courses/anatomy-of-a-flow-welcome-series/1881997`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_button_label = () => `학습 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_excerpt = () => `개인화된 환영 이메일 시리즈를 작성하고, 구독자와 강력한 관계를 형성하기 위한 모범 사례를 알아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_cards_third_title = () => `플로우의 해부학: 환영 이메일 시리즈`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_headline = () => `새롭고 주목할 만한 기능`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_newAndNoteworthy_subhead = () => `글로벌 전문가로 구성된 팀의 최신 교육 코스, 가이드, 트레이닝을 확인하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_href = () => `/ko-kr/search`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_button_label = () => `모든 리소스 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_collectionPath = () => `/ko-kr/collections/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_coursePath = () => `/ko-kr/courses/`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedIn_title = () => `추천 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_href = () => `/ko-kr/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_button_label = () => `시작 가이드 모두 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_description = () => `전자상거래 에코시스템을 통합하고, 구독자를 수집하고, Klaviyo를 통해 메시지 전송을 시작하는 방법을 알아보세요.`


export { academy_pages_home_start_loggedOut_start1_divider } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_href = () => `/ko-kr/courses/getting-started-with-klaviyo/1459179`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_pill = () => `교육 코스, 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start1_title = () => `가입 양식으로 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_description = () => `세그먼트의 정의, 세그먼트를 만드는 방법, 세그먼트를 사용하여 타겟팅이 잘 된 마케팅 캠페인을 전송하는 방법을 알아보세요.`


export { academy_pages_home_start_loggedOut_start2_divider } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_href = () => `/ko-kr/courses/getting-started-with-sms/1411601`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_pill = () => `교육 코스, 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start2_title = () => `세그먼트 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_description = () => `Klaviyo 캠페인이 막혔나요? 캠페인 시작하기 교육 코스에서 143,000개 브랜드의 내부자 비결을 배우고 레벨업하세요.`


export { academy_pages_home_start_loggedOut_start3_divider } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_href = () => `/ko-kr/courses/getting-started-with-klaviyo-cdp/1759043`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_pill = () => `시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start3_title = () => `캠페인 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_description = () => `Klaviyo에서 플로우 기초를 배우고, 자동화된 플로우를 최초 구축하고, 모범 사례를 따라 수익을 늘리세요.`


export { academy_pages_home_start_loggedOut_start4_divider } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_href = () => `/ko-kr/courses/develop-a-klaviyo-reviews-strategy/1630005`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_metadata = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_pill = () => `시작하기, 교육 코스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_start4_title = () => `플로우 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_start_loggedOut_title = () => `기본부터 시작`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_headline = () => `고객의 의견`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_button_label = () => `교육 등록하기`


export { academy_pages_home_testimonials_quote1_size } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote1_text = () => `예시. 전문가들의 작업 방식을 보는 것은 항상 도움이 됩니다. 이 교육 덕분에 Klaviyo에서 탐색하고 작업하는 방법을 배웠습니다. <3`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_button_label = () => `교육 등록하기`


export { academy_pages_home_testimonials_quote2_size } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote2_text = () => `실제 사례와 단계별 지침 및 모범 사례는 놀라웠습니다. Klaviyo의 웨비나는 지금까지 참여해본 것 중에 가장 가치 있었습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_button_label = () => `교육 등록하기`


export { academy_pages_home_testimonials_quote3_size } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote3_text = () => `경쾌하고 직설적이며 간결합니다. 군더더기가 없어요. 시간이 아깝지 않도록 해 주셨어요. 훌륭한 데모입니다!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_href = () => `/ko-kr/search?select=Live+training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_button_label = () => `교육 등록하기`


export { academy_pages_home_testimonials_quote4_size } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const academy_pages_home_testimonials_quote4_text = () => `연사가 정말 마음에 들었어요. 모두 지식이 풍부하고 매력적인 방식으로 콘텐츠를 전달하는 능력이 있었습니다. 이 세션을 기획하는 데 도움이 된 주최측의 인사이트와 아이디어에 감사드립니다.  감사해요, Klaviyo! 세션이 끝날 무렵 제 머릿속은 고객을 위한 아이디어로 가득 찼습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alertBar_dismiss = () => `메시지 끄기`


export { atoms_singleLineForm_error } from "./en-US.js"

export { atoms_singleLineForm_placeholderText } from "./en-US.js"

export { atoms_singleLineForm_primaryButton } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_skipButton_skipContent = () => `메인 콘텐츠로 건너뛰기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_currentSlide = () => `현재 슬라이드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const atoms_slideIndicator_goToSlide = () => `슬라이드로 가기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_blog = () => `블로그`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_home = () => `홈`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_searchAll = () => `모두 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_sitemap = () => `사이트맵`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_general = () => `참고`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_requirements = () => `요구 사항`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_article_callout_warning = () => `경고`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_name = () => `주요 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_components_topicsMenu_featuredResources_slug = () => `/hc/ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_account = () => `계정 액세스 요청`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_article = () => `도움말 문서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_category = () => `카테고리`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_metaDesc = () => `Klaviyo의 기술 자료를 검색하여 가장 자주 묻는 질문에 대한 답변을 찾아보세요. 도움말 문서, 커뮤니티 포럼, 실시간 및 녹화 교육 등을 검색하여 Klaviyo 사용 방법에 대한 모든 것을 알아보고 모범 사례를 찾아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_opengraphSiteName = () => `Klaviyo 고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_search = () => `검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_section = () => `섹션`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_globalHead_title = () => `Klaviyo 고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_moreCardHeadline = () => `Klaviyo에서 자세히 살펴보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_layout_searchHeadline = () => `오늘 무엇을 도와드릴까요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_href = () => `/hc/ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_button_label = () => `고객센터로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_pages_404_titleText = () => `찾을 수 없음 | Klaviyo 고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_siteName = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_category_topArticles = () => `인기 도움말 문서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_headline = () => `주요 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_featuredResources_subhead = () => `Klaviyo에서 비즈니스 성장을 위한 교육 가이드, 교육 과정 및 자료를 확인하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL20R80_headline = () => `주제별 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_home_twoColumnL30R70_headline = () => `주제별 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsInstantSearch = () => `결과 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperSuggestion = () => `다른 검색을 시도해 보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_noResults_noResultsWrapperText = () => `다음에 대한 검색 결과 없음:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_academy_headline = () => `아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_community_headline = () => `커뮤니티`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_developers_headline = () => `개발자`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_helpCenter_headline = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_marketing_headline = () => `마케팅 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const helpCenter_templates_search_searchData_viewAll = () => `전체 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCode_languageString = () => `Korean`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_locale = () => `ko-KR`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_localeLowerCase = () => `ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_pathPrefix = () => `kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_recaptchaLanguage = () => `ko`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const langCodes_timezone = () => `Asia/Seoul`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates = () => `예정된 날짜`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_estimated = () => `예상`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_minuteRead = () => `읽은 시간(분)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleMeta_updated = () => `업데이트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_contactSupport = () => `지원 팀에 문의하는 방법`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_checkBoxLabel = () => `Klaviyo로부터 피드백과 관련하여 연락 받는 것을 허용합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_describe = () => `하고자 하는 것, 배우거나 해결하고자 하는 것을 설명해 주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_errorLabel = () => `이메일 주소는 @ 표시를 하나만 쓰고 그 뒤에 유효한 도메인이 포함되어야 합니다(name@example.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticle = () => `이 도움말 문서를 어떻게 개선할 수 있을까요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_improveArticleSuggestion = () => `좋았던 점이나 도움말 문서의 개선 방법에 관해 말해주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_incompleteLabel = () => `보다 자세한 내용이나 설명이 필요합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_irrelevantLabel = () => `검색한 내용과 연관이 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_legend = () => `알려주셔서 감사합니다! 문제에 관해 더 자세히 말씀해 주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_moreDetail = () => `자세히 설명해주실 수 있나요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_submit = () => `제출`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_description = () => `이 도움말 문서의 피드백과 관련해서만 연락을 드립니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_label = () => `이메일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_textInput_placeholder = () => `name@example.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_unclearLabel = () => `불분명하거나 혼란스럽거나 이해하기 어렵습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_form_wrongLabel = () => `제품 경험과 일치하지 않습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_furtherAssistance = () => `이 형식은 도움말 문서 피드백 용도로만 사용하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_headline = () => `이 도움말 문서가 유용했나요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_no = () => `아니요`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_success = () => `피드백이 제출되었습니다. 감사합니다!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_thanks = () => `도움이 되었다니 다행입니다!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_articleVoteForm_yes = () => `예`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_authorAltText = () => `작성자의 프로필 사진`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_defaultAuthorAltText = () => `Klaviyo 이미지`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogAuthor_minRead = () => `읽은 시간(분)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_blogCard_read = () => `읽음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_days = () => `일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_hours = () => `시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_minutes = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_countdownTimer_seconds = () => `초`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_filterBlock_topic = () => `주제`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseDepartment_openRoles = () => `채용 공고`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_save = () => `저장`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_greenhouseJob_saved = () => `저장됨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_next = () => `다음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_pagination_previous = () => `이전`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_relatedCard_openInANewTab = () => `새 탭에서 열기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_searchBox_placeholder = () => `주제 또는 키워드별 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articleSingular = () => `도움말 문서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_subcategoryCard_articlesPlural = () => `도움말 문서`


/**
 * @param {{ days: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_d = (params) => `${params.days}일`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_h = (params) => `${params.hours}시`


/**
 * @param {{ minutes: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_m = (params) => `${params.minutes}분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_countdown_now = () => `지금`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_day = () => `일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_days = () => `일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hour = () => `시`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_hours = () => `시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minute = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_minutes = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartIn = () => `이 이벤트는 다음과 같이 시작됩니다`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const molecules_unifiedSearchResultGridItem_countdownBadge_tooltip_thisEventStartsNow = () => `이 이벤트는 지금 시작합니다`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_href = () => `/auth/logout`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_logOut_label = () => `아카데미에서 로그아웃`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentialsOnAccredible_label = () => `Accredible에서 내 자격 증명 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_href = () => `https://v2.accounts.accredible.com/retrieve-credentials`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_myCredentials_label = () => `내 자격 증명 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_profile_label = () => `내 아카데미 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_href = () => `/auth/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_academy_signIn_label = () => `아카데미에 로그인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_href = () => `https://www.klaviyo.com/contact-us`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_ecosystem_ctas_contactUs_label = () => `문의하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_href = () => `https://www.klaviyo.com/dashboard`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_account_label = () => `계정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_logIn_label = () => `로그인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_href = () => `https://www.klaviyo.com/support`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_platformActions_support_label = () => `지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_href = () => `https://www.klaviyo.com/search-all`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const navigation_siteActions_search_label = () => `검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_anchorLinks_backToTop = () => `맨 위로 돌아가기`


export { organisms_articleTableContents_overview } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_articleTableContents_tableContents = () => `목차`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_eyebrow = () => `블랙프라이데이와 사이버먼데이(BFCM) 2024`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headline = () => `매일을 의미있게`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iAm = () => `저는`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_iWantTo = () => `제가 원하는 건`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_bfcmHero_headlineFilter_thisBfcm = () => `이번 블랙프라이데이와 사이버먼데이(BFCM)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogArticleHero_featureImageAltText = () => `주요 이미지`


export { organisms_blogCards_viewAll } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogCards_viewCategory = () => `카테고리 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_tagline = () => `갖고 있는 마케팅 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_blogLogoTag_title = () => `Klaviyo 접근 방식`


export { organisms_blogSearchHero_customSearchHeadline } from "./en-US.js"

export { organisms_blogSearchHero_placeholder } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_days = () => `일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_hours = () => `시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_minutes = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_countdownHero_seconds = () => `초`


export { organisms_emailSubjectLineGenerator_campaignType } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_announcement } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productLaunch } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productPromotion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_productUpdate } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_campaignType_storewideSale } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_examplePrompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_beauty_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_cpg_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productLaunch_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_fashion_productPromotion_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_productUpdate_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_homeGarden_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_announcement_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_prompt } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result1 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result10 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result11 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result12 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result2 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result3 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result4 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result5 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result6 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result7 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result8 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_industry_options_restaurantWellness_storewideSale_result9 } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_loading } from "./en-US.js"

export { organisms_emailSubjectLineGenerator_submit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_excerpt = () => `스토어를 통합하고 Klaviyo로 메시지를 시작하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_href = () => `https://academy.klaviyo.com/en-us/search?select=Getting+started`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_postTitle = () => `Klaviyo 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card1_resource = () => `아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_excerpt = () => `성공적인 SMS 전송을 위한 토대를 마련하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_href = () => `/hc/ko-kr/articles/4404274419355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_postTitle = () => `Klaviyo에서 SMS로 설정하는 방법`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card2_resource = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_excerpt = () => `첫 번째 이메일 캠페인을 생성 및 전송하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_href = () => `/hc/ko-kr/articles/115005054847`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_postTitle = () => `이메일 캠페인 생성 및 전송 방법`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card3_resource = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_excerpt = () => `양식을 사용하여 구독자와 상호 작용하고 구독자에 대한 더 많은 정보를 수집하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_href = () => `/hc/ko-kr/articles/360026474752`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_postTitle = () => `가입 양식으로 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card4_resource = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_excerpt = () => `자연어 입력을 사용하여 대규모로 완전한 플로우를 생성하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_href = () => `/hc/ko-kr/articles/26604555031963`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_postTitle = () => `플로우 AI를 사용하여 플로우를 구축하는 방법`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card5_resource = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_excerpt = () => `고객 피드백을 수집하고 더 많은 전환을 유도하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_href = () => `/hc/ko-kr/articles/15937542819355`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_postTitle = () => `리뷰 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuredResources_card6_resource = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_featuresList_loadMore = () => `더 로드하기`


/**
 * @param {{ year: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_copyright = (params) => `Copyright © ${params.year} Klaviyo. All rights reserved.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_footer_privacySettings = () => `개인정보 설정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_articleMetaTitle = () => `계정 액세스 요청`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_href = () => `/hc/ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_breadcrumb_label = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_currentBreadcrumb = () => `계정 액세스 요청`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_email = () => `이메일 주소는 @ 표시를 하나만 쓰고 그 뒤에 유효한 도메인이 포함되어야 합니다(name@example.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_issueRecipeients = () => `유효한 이메일을 입력하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_na_required = () => `필수 - 해당되지 않을 경우 'NA'로 응답`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_error_websiteUrl = () => `회사 웹사이트에는 유효한 도메인이 포함되어야 합니다(https://example.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_label = () => `계정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_account_placeholder = () => `계정 이름 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_button_label = () => `+ 수신자 추가`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_label = () => `추가 수신자(선택 사항)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_addRecipients_placeholder = () => `이메일 주소 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_label = () => `Klaviyo 계정 이메일 주소`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_email_placeholder = () => `이메일 주소 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_label = () => `어떤 도움이 필요하신가요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_help_placeholder = () => `문제 설명`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_2_step_authentication = () => `다단계 인증`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_account_disabled = () => `계정 비활성화됨`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_forgot_password = () => `비밀번호 찾기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_invoice_inquiry = () => `인보이스 조회`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_multifactor_authentication_support = () => `다단계 인증 지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_account_owner = () => `계정 소유자 업데이트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_new_device_code = () => `새 기기 설정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issueType_setting_up_new_device = () => `새 기기 설정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_label = () => `문제`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_issue_placeholder = () => `문제 선택`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name = () => `마지막으로 생성된 캠페인 또는 플로우 이름`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_campaign_flow_name_placeholder = () => `캠페인 또는 플로우 이름 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url = () => `회사 웹사이트에 'Klaviyo Test'라는 제목으로 새 페이지를 만든 다음 여기에 URL을 입력합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_company_test_url_placeholder = () => `웹사이트 URL 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info = () => `보안 목적을 위해, 다음 신원 확인 질문에 성실히 답해주시기를 바랍니다. 확실하지 않다면 'NA'를 입력하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_info = () => `이 양식은 인증 기기에 대한 액세스 권한 상실과 같은 다단계 인증(MFA) 문제가 있을 경우에만 사용하세요. 이 양식에는 수동 인증을 위한 개인 정보를 입력해야 합니다. 다단계 인증 문제가 아닌 경우 다른 옵션을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date = () => `마지막 예상 로그인 날짜`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_last_login_date_placeholder = () => `날짜 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address = () => `수신 대상 조직의 등록된 주소`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_org_mailing_address_placeholder = () => `주소 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails = () => `계정에 있는 다른 사용자의 이름 또는 이메일 주소`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_other_emails_placeholder = () => `이름 또는 이메일 주소 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names = () => `계정 내에서 1개월 이상 지난 5개 프로필의 이름 또는 이메일 주소`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_profile_names_placeholder = () => `이름 또는 이메일 주소 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason = () => `사유 선택`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_lost_access_authenticator_app = () => `보안 인증 앱에 액세스할 수 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_device = () => `새 기기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_new_phone_number = () => `새 전화번호`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_reason_sms_code = () => `SMS 코드를 받지 못했습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice = () => `최근에 받은 Klaviyo 청구서의 금액은 얼마였나요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_mfa_support_recent_invoice_placeholder = () => `청구서 금액 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_label = () => `이름`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_name_placeholder = () => `전체 이름 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_submit_button_label = () => `제출`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_label = () => `웹사이트 URL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_form_websiteUrl_placeholder = () => `웹사이트 URL 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_headline = () => `계정 액세스에 문제가 있나요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_subhead = () => `지원 팀에 정보를 제출하시면 곧 담당자가 연락을 드릴 것입니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_href = () => `/hc/ko-kr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_button_label = () => `홈으로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_headline = () => `요청 제출 완료`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_accountAccessForm_success_subhead = () => `지원 팀에서 최대한 빨리 연락드리겠습니다. 입력한 이메일로 답변이 전송됩니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_allRequired = () => `모든 필드는 필수 입력 사항입니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_body = () => `Klaviyo의 데이터 플랫폼, AI 기반 인사이트, 개인화된 SMS 및 이메일 등의 기능을 무료로 살펴보세요. `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_button = () => `데모 체험하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_buttonSubmitting = () => `제출 중...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headline = () => `브랜드에 대해 알려주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_headlineEmbedded = () => `브랜드에 대해 알려주세요.`


export { organisms_forms_demo_recaptcha_privacy } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonOne = () => `모든 기능 살펴보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_buttonTwo = () => `마케팅 리소스 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_demo_success_headline = () => `모든 준비가 완료되었습니다!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_generic = () => `요청이 성공하지 못했습니다. 다시 시도해 주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_network = () => `네트워크 오류로 인해 요청이 성공하지 못했습니다. 다시 시도해 주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_rateLimit = () => `짧은 시간 내에 지나치게 여러 번 가입했습니다. 기존 계정을 활용하거나 고객 지원 팀에 문의하여 추가 지원을 받으시기 바랍니다. 감사합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_errors_recaptcha = () => `reCaptcha 필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_agency_label = () => `고객을 위해 대행사로서 가입했습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_errors_required = () => `회사 이름을 입력해 주세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_label = () => `회사 이름`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_placeholder = () => `회사 이름을 입력하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_errors_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_label = () => `고객 연락처 수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_fiveHundred = () => `500,000~1,000,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_one = () => `1,000~3,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneHundred = () => `100,000~500,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_oneMillion = () => `1,000,000개 이상`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_three = () => `3,000~25,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_twentyFive = () => `25,000~100,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_options_zero = () => `0~1,000개`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_size_placeholder = () => `고객 연락처 수 선택`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_errors_url = () => `회사 웹사이트에는 유효한 도메인이 포함되어야 합니다(https://example.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_company_website_label = () => `회사 웹사이트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_demo_requested_label = () => `실시간 상담/안내를 받고 싶습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_errors_required = () => `제품을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_label = () => `전자상거래 플랫폼`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_BigCommerce = () => `BigCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Commercetools = () => `Commercetools`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Magento = () => `Adobe Commerce(Magento)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Nuvemshop = () => `Nuvemshop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_OpenCart = () => `OpenCart`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_PrestaShop = () => `PrestaShop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Salesforce = () => `Salesforce Commerce Cloud`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopify = () => `Shopify`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_ShopifyPlus = () => `Shopify Plus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Shopware = () => `Shopware`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_SquareOnline = () => `Square Online`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_Wix = () => `Wix Stores`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_WooCommerce = () => `WooCommerce`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_custom = () => `사용자 정의한 것이 있습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_doesNotApply = () => `내 비즈니스에 적용되지 않음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_options_other = () => `목록에 없는 전자상거래 플랫폼`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_ecomm_platform_placeholder = () => `플랫폼 선택`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_email = () => `이메일 주소는 @ 표시를 하나만 쓰고 그 뒤에 유효한 도메인이 포함되어야 합니다(name@example.com).`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_errors_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_label = () => `이메일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_email_placeholder = () => `name@example.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_errors_required = () => `연간 예상 수익을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_label = () => `연간 예상 수익`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_five = () => `5백만 달러~2천만 달러`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_fourHundred = () => `4억 달러 이상`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_twenty = () => `2천만 달러~4억 달러`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_options_underFive = () => `5백만 달러 미만`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_15_placeholder = () => `연간 예상 수익을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_errors_required = () => `Klaviyo를 어떻게 사용할 것인지 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_label = () => `Klaviyo를 어떻게 사용하실 건가요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_clientsBusiness = () => `고객의 비즈니스를 위해`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_options_ownBusiness = () => `내 비즈니스를 위해`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_16_placeholder = () => `Klaviyo를 어떻게 사용할 것인지 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_errors_required = () => `비즈니스 유형을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_label = () => `비즈니스 유형`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_other = () => `기타 비소매 제품 및 서비스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailGoods = () => `소매 제품`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_options_retailServices = () => `소매 서비스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_field_17_placeholder = () => `비즈니스 유형 선택`


export { organisms_forms_fields_firstname_errors_required } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_errors_required = () => `이름을 입력하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_label = () => `이름`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_full_name_placeholder = () => `전체 이름`


export { organisms_forms_fields_general_errors_required } from "./en-US.js"

export { organisms_forms_fields_lastname_errors_required } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_newsletter_label = () => `뉴스레터, 블로그 게시물, 제품 뉴스, 웨비나, 표적화된 광고 등 Klaviyo의 마케팅 커뮤니케이션에 가입하세요. 이메일의 구독 취소 링크를 통해 이메일 마케팅 수신을 취소할 수 있습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_common = () => `너무 흔한 비밀번호입니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_max = () => `비밀번호는 128자를 넘길 수 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_min = () => `비밀번호는 8자 이상이어야 합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_errors_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_label = () => `비밀번호`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_password_placeholder = () => `비밀번호 입력`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_matches = () => `전화번호에 지역 번호 또는 국가 번호를 포함하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_max = () => `번호는 15자 이하여야 합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_errors_required = () => `필수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_label = () => `전화번호`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_phone_placeholder = () => `전화번호를 입력하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_errors_required = () => `제품을 선택하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_label = () => `어떤 제품에 관심이 있으신가요? 해당되는 항목을 모두 선택합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_cdp = () => `고객 데이터 플랫폼`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_email = () => `이메일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_mobile_push = () => `모바일 푸시`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_reviews = () => `후기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_options_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_fields_product_interest_placeholder = () => `제품 선택`


export { organisms_forms_fields_website_errors_url } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_acknowledgement = () => `이 양식을 제출하면 다음 약관에 동의하는 것입니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_and = () => `및`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_href = () => `/legal/privacy/privacy-notice`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_privacyPolicy_label = () => `개인정보 보호정책`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService = () => `서비스 이용 약관`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_legal_termsOfService_href = () => `/legal/terms-of-service`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_body = () => `판매로 전환되는 타겟 SMS 및 이메일 메시지를 통해 몇 분 안에 첫 번째 캠페인을 보내고, 자동 마케팅을 시작하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_button = () => `계정 생성`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_buttonSubmitting = () => `제출 중...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_forms_signup_headline = () => `지금 바로 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_glossary_jumpTo = () => `다음으로 이동:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_allLocations = () => `모든 위치`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_search = () => `검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_jobSearch_searchJobs = () => `채용 정보 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_allSystemsOperational = () => `모든 시스템 운영 중`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_degradedSystemService = () => `시스템 서비스 저하`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_majorSystemOutage = () => `주요 시스템 중단`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorServiceOutage = () => `경미한 서비스 중단`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_minorSystemOutage = () => `경미한 시스템 중단`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partialSystemOutage = () => `부분적 시스템 중단`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedService = () => `부분적으로 저하된 서비스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_partiallyDegradedSystem = () => `부분적으로 저하된 시스템`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_klaviyoStatusIndicator_status_serviceUnderMaintenance = () => `유지 관리 중인 서비스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_modal_closeModal = () => `모달 닫기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_href = () => `https://community.klaviyo.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_button_label = () => `커뮤니티 방문`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_eyebrow = () => `커뮤니티`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_icon_iconName = () => `커뮤니티`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card1_richText = () => `동료, 파트너, Klaviyo 전문가와 연결되어 영감을 받고 인사이트를 공유하며, 모든 궁금한 사항에 대해 답을 얻으세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_href = () => `https://www.klaviyo.com/events/live-training`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_button_label = () => `지금 등록하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_eyebrow = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_icon_iconName = () => `캘린더`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card2_richText = () => `Klaviyo 전문가와 함께하는 라이브 세션에 참여하여 모범 사례, 주요 기능 설정 방법 등에 대해 알아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_href = () => `https://www.klaviyo.com/login`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_button_label = () => `로그인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_eyebrow = () => `지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_icon_iconName = () => `지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_accessSupport = () => `계정을 통해 지원에 액세스하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistance = () => `채팅/가상 비서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_chatVirtualAssistanceAvailability = () => `사용 가능 여부는 위치 및 요금제 유형에 따라 다름`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupport = () => `이메일 지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAccountTypes = () => `(무료 체험 및 유료 계정)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_moreCards_card3_richText_emailSupportAvailability = () => `연중무휴 24시간 사용 가능`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewAllButton_text = () => `카테고리 모두 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigationCategorySelection_viewLessButton_text = () => `카테고리 간략히 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_href = () => `/demo-request`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_getADemo_button_label = () => `데모 체험하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_dataActions_signUp_button_href = () => `/sign-up`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_logo_label = () => `Klaviyo 홈페이지로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_href = () => `https://www.klaviyo.com/customer-resources`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_navigation_powerUpLogo_label = () => `Klaviyo 파워 업 리소스 페이지로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_klavioLogo = () => `Klaviyo 로고`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_productNews = () => `Klaviyo 제품 뉴스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_read = () => `읽음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_newsFeed_viewAll = () => `전체 보기`


export { organisms_post_filter_ResourceCategory } from "./en-US.js"

export { organisms_post_filter_ResourceCollection } from "./en-US.js"

export { organisms_post_filter_ResourceStage } from "./en-US.js"

export { organisms_post_filter_ResourceTopic } from "./en-US.js"

export { organisms_post_filter_read_more } from "./en-US.js"

export { organisms_post_filter_search } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimer = () => `이동 통신사 예상 수수료 포함:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_carrierFeeDisclaimerEnd = () => `SMS/MMS당 가격은 메시지 길이에 따라 달라질 수 있습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credit = () => `(크레딧)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_credits = () => `(크레딧)`


export { organisms_pricing_calculator_destination } from "./en-US.js"

export { organisms_pricing_calculator_headline } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AT = () => `오스트리아`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_AU = () => `호주`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BE = () => `벨기에`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CA = () => `캐나다`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_CH = () => `스위스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DE = () => `독일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_DK = () => `덴마크`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_ES = () => `스페인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FI = () => `핀란드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_FR = () => `프랑스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_GB = () => `영국`


export { organisms_pricing_calculator_locales_HU } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IE = () => `아일랜드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_IT = () => `이탈리아`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NL = () => `네덜란드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NO = () => `노르웨이`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_NZ = () => `뉴질랜드`


export { organisms_pricing_calculator_locales_PL } from "./en-US.js"

export { organisms_pricing_calculator_locales_PT } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_SE = () => `스웨덴`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_US = () => `미국`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_maxSends = () => `최대 전송`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_mms = () => `MMS`


export { organisms_pricing_calculator_mms_limit } from "./en-US.js"

export { organisms_pricing_calculator_mms_not_available } from "./en-US.js"

export { organisms_pricing_calculator_not_available } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_pricePer = () => `가격`


export { organisms_pricing_calculator_pricePerSend } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sendTo = () => `전송 대상:`


export { organisms_pricing_calculator_service_type } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_sms = () => `SMS`


export { organisms_pricing_calculator_sms_limit } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contactLimitExceeded = () => `활성 프로필 제한 초과`


export { organisms_pricing_contactSales } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_contacts = () => `활성 프로필`


export { organisms_pricing_contacts_slider_headline } from "./en-US.js"

export { organisms_pricing_contacts_slider_subText } from "./en-US.js"

export { organisms_pricing_contacts_slider_subTextInfo } from "./en-US.js"

export { organisms_pricing_credits_slider_headline } from "./en-US.js"

export { organisms_pricing_credits_slider_subText } from "./en-US.js"

export { organisms_pricing_credits_slider_subTextInfo } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_csm = () => `고객 성공 매니저(CSM): 월 $1,500`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_emailAndChatSupport = () => `이메일 및 채팅 지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_eyebrow = () => `견적을 받으세요`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeCredits = () => `무료 월간 SMS/MMS 크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_freeSupport = () => `첫 60일 동안 이메일 지원`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_getADemo = () => `데모 체험하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_headline = () => `활성 프로필을 몇 개 갖고 계신가요?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_includesFees = () => `적용 가능한 SMS 통신사 요금 포함`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_buttons_getDemo = () => `데모 체험하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_headline = () => `이야기 나누기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_maxContacts_richTextBody = () => `활성 프로필이 25만 개가 넘는 경우, 영업 팀에 문의하여 적합한 요금제를 찾아보세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_mobilePush = () => `모바일 푸시 알림`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText1 = () => `크레딧을 SMS 메시지, MMS 메시지 또는 둘 다에 사용할 수 있습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_copyText2 = () => `SMS 및 MMS 메시지 요금은 수신자의 위치에 따라 달라집니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_modalContent_headline = () => `SMS/MMS 크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_month = () => `월`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlyEmailSends = () => `월간 이메일 전송`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_monthlySmsMmsCredits = () => `월간 SMS/MMS 크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_onboarding = () => `온보딩: 월 $450`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_opensAModal = () => `(모달 열기)`


export { organisms_pricing_per_month } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextTooltiptInfo } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_advanced_data_platform_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_collapsible_button } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_copy = () => `이메일과 문자 메시지를 통해 고객사에 도달하여 마케팅을 더욱 강화할 수 있습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_emailAndSms_name = () => `이메일과 문자 메시지`


export { organisms_pricing_plans_emailPlusSms_creditsSubText } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_name } from "./en-US.js"

export { organisms_pricing_plans_emailPlusSms_recommended } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_copy = () => `대규모로 개인화할 수 있는 단순한 솔루션을 통해 이메일 마케팅에서 다음 단계로 나아가세요.`


export { organisms_pricing_plans_email_emails_label } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_email_name = () => `이메일`


export { organisms_pricing_plans_email_per_month } from "./en-US.js"

export { organisms_pricing_plans_expandable_button } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_calloutText = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_copy = () => `Klaviyo 고객 플랫폼을 시작하고 사용해 보기에 적합합니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plans_free_name = () => `무료`


export { organisms_pricing_plans_free_subtext_bottom } from "./en-US.js"

export { organisms_pricing_plans_free_subtext_top } from "./en-US.js"

export { organisms_pricing_plans_getStarted_text } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_headline } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_price_subText } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_marketing_analytics_subText } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_above250kContacts } from "./en-US.js"

export { organisms_pricing_plans_paidCardContent_below250Contacts } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subText } from "./en-US.js"

export { organisms_pricing_plans_platform_advanced_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_platform_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_headline } from "./en-US.js"

export { organisms_pricing_plans_reviews_pricingDescription } from "./en-US.js"

export { organisms_pricing_plans_reviews_slider_subText } from "./en-US.js"

export { organisms_pricing_plans_reviews_subText } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_plusSign = () => `+`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_creditEntrySms = () => `SMS = 4크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionAUS_regionName = () => `호주`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntryMms = () => `MMS = 5크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_creditEntrySms = () => `SMS = 3크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionCanada_regionName = () => `캐나다`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_creditEntrySms = () => `SMS = 7크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionFrance_regionName = () => `프랑스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_creditEntrySms = () => `SMS = 12크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionGermany_regionName = () => `독일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_creditEntrySms = () => `SMS = 9크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionIreland_regionName = () => `아일랜드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_creditEntrySms = () => `SMS = 7크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionItaly_regionName = () => `이탈리아`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_creditEntrySms = () => `SMS = 10크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNZ_regionName = () => `뉴질랜드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_creditEntrySms = () => `SMS = 12크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionNetherlands_regionName = () => `네덜란드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_creditEntrySms = () => `SMS = 3크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionPortugal_regionName = () => `포르투갈`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntryMms = () => `MMS = 해당 없음`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_creditEntrySms = () => `SMS = 5크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUK_regionName = () => `영국`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntryMms = () => `MMS = 3크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_creditEntrySms = () => `SMS = 1크레딧`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_rates_regionUSA_regionName = () => `미국`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_signUp = () => `회원가입`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_startingAt = () => `시작:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_supportToScale = () => `비즈니스 확장을 위한 지원`


export { organisms_scroll_social_proof_button } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionCredentials_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_attributionName_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_headline_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_href_3 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_1 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_2 } from "./en-US.js"

export { organisms_scroll_social_proof_card_quote_3 } from "./en-US.js"

export { organisms_scroll_social_proof_href } from "./en-US.js"

export { organisms_scroll_social_proof_quote_end } from "./en-US.js"

export { organisms_scroll_social_proof_quote_start } from "./en-US.js"

export { organisms_searchBar_placeholder_case_study } from "./en-US.js"

export { organisms_searchBar_placeholder_compare_page } from "./en-US.js"

export { organisms_searchBar_placeholder_marketing_resource } from "./en-US.js"

export { organisms_searchBar_placeholder_newsroom_article } from "./en-US.js"

export { organisms_searchBar_placeholder_page } from "./en-US.js"

export { organisms_searchBar_placeholder_partner_page } from "./en-US.js"

export { organisms_searchBar_placeholder_podcast_page } from "./en-US.js"

export { organisms_searchBar_placeholder_post } from "./en-US.js"

export { organisms_searchBar_placeholder_product_update } from "./en-US.js"

export { organisms_searchBar_placeholder_solutions_page } from "./en-US.js"

export { organisms_searchBar_placeholder_success_page } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_button } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_href } from "./en-US.js"

export { organisms_solutionsScrollAccordion_bottom_subhead } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_benchmarks } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_customer_hub } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_email_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_integrations } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_klaviyo_ai } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_mobile_push } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_profiles } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reporting } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_reviews } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_segments } from "./en-US.js"

export { organisms_solutionsScrollAccordion_pill_sms_marketing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_button_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_button_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_e } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_f } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_1_href_g } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_2_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_3_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_button_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_c } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_arr_4_href_d } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_explore_title_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_headline_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_href_4 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_27Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_43Percent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_a } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_b } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_consentedToReceiveSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_createWithAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_describeFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_dontLeaveItBehind } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_generateDraft } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_hasViewedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_klaviyoAI } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_smsABTest } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_viewAbandonedProduct } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_weLoveThatYouLoveThisDontLeaveItBehindClickToShop } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_whenSomeoneViewsAProductAndDoesNotBuySendAnSMS } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_1_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_attributedRevenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_champions } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_championsFlow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_clickRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionOverview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_conversionRate } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_eightPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_excellent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_exclusiveOffer } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fivePointTwoZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fortyThreeThousandSixHundredNineteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_fourHundredFiftyTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersAdded } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_membersDropped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthOne } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_monthTwo } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_oneThousandFiveHundredThirteen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenue } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_revenueNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_rfmGroupIsChampion } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_segmentGrowthReport } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_sevenPointFiveZeroPercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_threePercent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_totalMembers } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_2_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_accessories } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_activity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToBag } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_addToCart } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_arrivingToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_chat } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_clothing } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_color } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_coral } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_featherweightRunningShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_findAStore } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_forYou } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_help } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_horizonRibbedTrainingSet } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_l } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_maroon } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_membersFreeShippingOnOrdersFiftyPlus } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliams } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_miaWilliamsAtAbcDotCom } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_myOrderJustArrivedAndItLooksLikeIWasShippedTheWrongSizeShoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_new } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_orders } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_phoneNumber } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_pleaseHoldForAMomentWhileWeConnectYouWithAnAgent } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_profile } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_recentlyViewed } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_saySomething } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_seanH } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_selectSize } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_shoes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sky } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_sorryAboutThatMiaWellGetTheCorrectColorShippedOutToday } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_thirtyFivePointNinetyNine } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_twoHundredTen } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_unifiedInbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_welcomeMia } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xs } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_xxl } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_3_yesThatsMyOrderThanksForYourHelp } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_Enjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_customerActivity } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_discountCode } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_email } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_flowTrigger } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_inbox } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_leftFiveStarReview } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_name } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_no } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_openedEmailDiscount } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderDelivered } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_orderShipped } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_placedOrderForTwoHundredSix } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_shopNow } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_tenPercentOff } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_thanksForYourFeedbackEnjoy } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_rive_4_yes } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_1 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_2 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_3 } from "./en-US.js"

export { organisms_solutionsScrollAccordion_row_subhead_4 } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_tileList_viewAll = () => `전체 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_video_playVideo = () => `동영상 재생`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_clearAll = () => `전체 지우기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_collapseAll = () => `모두 접기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_filterTitle = () => `모든 업데이트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_placeholder = () => `검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_accounts_billing = () => `계정 및 청구`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_advanced_kdp = () => `고급 KDP`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_analytics = () => `분석`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_audience = () => `오디언스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_benefits = () => `혜택`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_campaigns = () => `캠페인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_coming_soon = () => `곧 출시 예정`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_deliver_compliance = () => `전송 가능성 및 규정 준수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_email = () => `이메일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_flows = () => `플로우`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_general_availability = () => `일반 가용성`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_gradual_release = () => `점진적 릴리스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_integrations = () => `연동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_limited_availability = () => `제한된 가용성`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_marketing_analytics = () => `마케팅 분석/애널리틱스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_push_notifications = () => `푸시 알림`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_release_type = () => `릴리스 유형`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_reviews = () => `후기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sign_up_forms = () => `가입 양식`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_refinements_topic = () => `주제`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_whatsNew_watchQuarterlyRecap = () => `분기별 요약 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_home = () => `홈`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_breadcrumbs_searchJobs = () => `채용 정보 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_applyFilters = () => `필터 적용`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_clearFilters = () => `필터 지우기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_country = () => `국가`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywords = () => `키워드`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_keywordsPlaceholder = () => `채용 정보 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_legend = () => `채용 공고 필터링`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_location = () => `위치`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResults = () => `죄송합니다. 기준에 부합하는 채용 공고가 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_noResultsReset = () => `다른 검색 기준으로 시도하거나 <a href="#" onclick="window.location.href='/careers/search-jobs'">채용 공고 모두 보기</a>를 클릭하세요.`


/**
 * @param {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_searchResults = (params) => `<strong>${params.start}</strong>~<strong>${params.end}</strong> 기간의 관련 채용 <strong>${params.total}</strong>개 표시`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_form_team = () => `팀`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_headline = () => `채용 정보 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_pageTitle = () => `채용 정보 검색 | Klaviyo Careers`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_recentJobs = () => `최근 조회 항목`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_careers_searchJobs_savedJobs = () => `저장된 포지션`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_bodyCopy = () => `찾던 결과가 아닌가요? <a href="/email-marketing">이메일 페이지</a>, <a href="/sms-marketing">SMS 페이지</a>로 이동하거나 <a href="/">홈페이지</a>를 방문하세요.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_button = () => `홈으로 이동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_eyebrow = () => `페이지를 찾을 수 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_notFound_itsPronounced = () => `발음은 다음과 같습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardHours = () => `시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardMinutes = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularHour = () => `시간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_cardSingularMinute = () => `분`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_community_answered = () => `답변이 완료된 질문`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_academy = () => `아카데미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_allResources = () => `모든 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_clearAll = () => `전체 지우기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_collapseAll = () => `모두 접기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_community = () => `커뮤니티`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_developers = () => `개발자`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_helpCenter = () => `고객센터`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_klaviyoHome = () => `마케팅 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_filters_resource = () => `리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_headline = () => `모든 리소스 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsSubTitle = () => `맞춤법을 확인하거나 다른 내용으로 검색을 시도하세요.`


/**
 * @param {{ query: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_noResultsTitle = (params) => `"${params.query}"에 대한 결과를 찾을 수 없습니다.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_placeholder = () => `주제 또는 키워드별 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_duration = () => `기간`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_language = () => `언어`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_location = () => `위치`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinementsAccordionLabel_academy_type = () => `유형`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_english = () => `영어`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_french = () => `프랑스어`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_language_spanish = () => `스페인어`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_apac = () => `아시아/호주`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_emea = () => `유럽/아프리카`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_location_nam = () => `북미`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_academy_type_liveTraining = () => `라이브 교육`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_category = () => `카테고리`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType = () => `게시물 유형`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_bfcm_page = () => `블랙프라이데이와 사이버먼데이`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_case_study = () => `사례 연구`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_compare_page = () => `비교`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_demos_page = () => `데모`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_industry_page = () => `업종`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_marketing_resource = () => `마케팅 리소스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_newsroom_article = () => `뉴스룸`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_page = () => `페이지`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_partner_page = () => `파트너`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_podcast_page = () => `팟캐스트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_post = () => `블로그`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_product_update = () => `제품 업데이트`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_products_page = () => `제품`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_quarterly_page = () => `분기별 출시`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_solutions_page = () => `솔루션`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_success_page = () => `성공`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_postType_tools_page = () => `도구`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_accounts_billing = () => `계정 및 청구`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_analytics = () => `분석`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_audience = () => `오디언스`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_campaigns = () => `캠페인`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_cdp = () => `고객 데이터 플랫폼`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_deliver_compliance = () => `전송 가능성 및 규정 준수`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_email = () => `이메일`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_flows = () => `플로우`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_integrations = () => `연동`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_klaviyo_ai = () => `Klaviyo AI`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_push_notifications = () => `푸시 알림`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_reviews = () => `후기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sign_up_forms = () => `가입 양식`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_refinements_klaviyoHome_topics_sms = () => `SMS`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelTop = () => `상위 검색 결과`


/**
 * @param {{ y: NonNullable<unknown>, x: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_resultLabelYofX = (params) => `${params.x} 중 ${params.y} 표시`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearchesTitle = () => `추천 검색`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search1 = () => `Klaviyo 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search2 = () => `SMS 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search3 = () => `Klaviyo CDP 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search4 = () => `양식 시작하기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search5 = () => `블랙 프라이데이 사이버 먼데이`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_suggestedSearches_search6 = () => `Klaviyo에서 콘텐츠 캘린더 생성`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_toggleLabel = () => `보기`


/**
 * @param {{ index: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewAllResults = (params) => `모든 ${params.index} 결과 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_search_viewMoreResults = () => `자세히 보기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_header = () => `카테고리`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pages_sitemap_title = () => `Klaviyo 사이트 맵`


export { roiCalculator_form_brandText } from "./en-US.js"

export { roiCalculator_form_channelsUsed } from "./en-US.js"

export { roiCalculator_form_fieldsRequired } from "./en-US.js"

export { roiCalculator_form_inputActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterActiveProfiles } from "./en-US.js"

export { roiCalculator_form_inputEnterAverageOrderValue } from "./en-US.js"

export { roiCalculator_form_inputEnterCampaignsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputEnterOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputEnterSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputFlowsPerMonth } from "./en-US.js"

export { roiCalculator_form_inputMonthlyWebVisitors } from "./en-US.js"

export { roiCalculator_form_inputOrdersPerMonth } from "./en-US.js"

export { roiCalculator_form_inputPrefix } from "./en-US.js"

export { roiCalculator_form_inputSmsPerMonth } from "./en-US.js"

export { roiCalculator_form_roiButton } from "./en-US.js"

export { roiCalculator_form_toggleEmail } from "./en-US.js"

export { roiCalculator_form_toggleEmailAndSms } from "./en-US.js"

export { roiCalculator_results_automatedFlows } from "./en-US.js"

export { roiCalculator_results_campaigns } from "./en-US.js"

export { roiCalculator_results_freeTier } from "./en-US.js"

export { roiCalculator_results_getStartedButton } from "./en-US.js"

export { roiCalculator_results_headlineText } from "./en-US.js"

export { roiCalculator_results_invalidRoi } from "./en-US.js"

export { roiCalculator_results_newSubscribers } from "./en-US.js"

export { roiCalculator_results_revenuePerYear } from "./en-US.js"

export { roiCalculator_results_signupText } from "./en-US.js"

export { roiCalculator_results_subHeadlineText } from "./en-US.js"

export { roiCalculator_results_talkToSales } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_openInANewTab = () => `새 탭에서 열기`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_author_postsByThisAuthor = () => `이 작성자의 게시물`


/**
 * @param {{ category_name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_articles = (params) => `도움말 문서`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_archive_category_featured = () => `주요`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_customer = () => `고객`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_industry = () => `업종`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const templates_caseStudy_platform = () => `플랫폼`


export { pages_b2ccrm_hero_video_id } from "./en-US.js"

export { pages_b2ccrm_introduction_subtext } from "./en-US.js"

export { pages_b2ccrm_marketing_p1 } from "./en-US.js"

export { pages_b2ccrm_marketing_p2 } from "./en-US.js"

export { pages_b2ccrm_marketing_p3 } from "./en-US.js"

export { pages_b2ccrm_service_p1 } from "./en-US.js"

export { pages_b2ccrm_service_rive_message_2 } from "./en-US.js"

export { pages_b2ccrm_service_rive_phone_number } from "./en-US.js"

export { pages_b2ccrm_analytics_rive_revenue_number_sign } from "./en-US.js"

export { pages_b2ccrm_platform_rive_placed_order } from "./en-US.js"

export { pages_b2ccrm_service_rive_dash_item_cost } from "./en-US.js"

export { pages_b2ccrm_service_rive_item_price } from "./en-US.js"

export { pages_b2ccrm_service_rive_shipping } from "./en-US.js"

export { roiCalculator_results_getStartedButton_href } from "./en-US.js"

export { roiCalculator_results_talkToSales_href } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Apply } from "./en-US.js"

export { AppMarketplace_Browse_Filters_BuiltBy } from "./en-US.js"

export { AppMarketplace_Browse_Filters_Category } from "./en-US.js"

export { AppMarketplace_Browse_Filters_CollapseAll } from "./en-US.js"

export { AppMarketplace_Browse_Filters_FilterItemWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabel } from "./en-US.js"

export { AppMarketplace_Browse_Filters_MobileFilterLabelWithCount } from "./en-US.js"

export { AppMarketplace_Browse_Filters_ResetAll } from "./en-US.js"

export { AppMarketplace_Browse_Heading } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Plural } from "./en-US.js"

export { AppMarketplace_Browse_Heading_SearchTermMatchCount_Singular } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Body_Alt } from "./en-US.js"

export { AppMarketplace_Browse_NoResults_Heading } from "./en-US.js"

export { AppMarketplace_Details_Articles_CaseStudyImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_NavigationIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Articles_UserGuideIcon_Alt } from "./en-US.js"

export { AppMarketplace_Details_Info_ApplicationLogo_Alt } from "./en-US.js"

export { AppMarketplace_Details_InstallButton_UninstallableWarningImage_Alt } from "./en-US.js"

export { AppMarketplace_Details_Page_Title } from "./en-US.js"

export { AppMarketplace_Discovery_App_BuiltBy } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_ActionRequired } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_GenericPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_Installed } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_NewHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardBody } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_PopularCardLink } from "./en-US.js"

export { AppMarketplace_Discovery_Apps_UserPopularHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Card_BannerImage_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Card_Icon_Alt } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllApps } from "./en-US.js"

export { AppMarketplace_Discovery_Divider_ViewAllAppsAriaLabel } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL1 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2 } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericHeadingL2Highlight } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_GenericMobileHeading } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_LogInAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_SignUpAction } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserGreeting } from "./en-US.js"

export { AppMarketplace_Discovery_Hero_UserHeading } from "./en-US.js"

export { AppMarketplace_Drawer_AccountManagement } from "./en-US.js"

export { AppMarketplace_Drawer_ApplicationManagement } from "./en-US.js"

export { AppMarketplace_Drawer_Categories } from "./en-US.js"

export { AppMarketplace_Header_CategoriesButton_Label } from "./en-US.js"

export { AppMarketplace_Header_LoginButton_Label } from "./en-US.js"

export { AppMarketplace_Header_Logo_Alt } from "./en-US.js"

export { AppMarketplace_Header_MenuIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_Placeholder } from "./en-US.js"

export { AppMarketplace_Header_SearchBar_SearchIcon_Alt } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_ApplicationsSection_Label } from "./en-US.js"

export { AppMarketplace_Header_SearchResults_CategoriesSection_Label } from "./en-US.js"

export { AppMarketplace_Preview_Site_Title } from "./en-US.js"

export { AppMarketplace_Site_Description } from "./en-US.js"

export { AppMarketplace_Site_Title } from "./en-US.js"

export { academy_lesson_bottom_nav_catalog_label } from "./en-US.js"

export { academy_lesson_bottom_nav_collection_label } from "./en-US.js"

export { academy_pages_bestPractices_headline } from "./en-US.js"

export { academy_pages_bestPractices_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_headline } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab1_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab2_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab3_subhead } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_label } from "./en-US.js"

export { academy_pages_bestPractices_tabs_tab4_subhead } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_italian_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_description } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_link } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_spanish_title } from "./en-US.js"

export { academy_pages_cred_card_deliverability_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_description } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_french_title } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_developer_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_omnichannel_strategy_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_description } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_german_title } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_product_certificate_title } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_description } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_link } from "./en-US.js"

export { academy_pages_cred_card_sales_certificate_title } from "./en-US.js"

export { academy_pages_cred_faq_headline } from "./en-US.js"

export { academy_pages_cred_faq_row0_content } from "./en-US.js"

export { academy_pages_cred_faq_row0_title } from "./en-US.js"

export { academy_pages_cred_faq_row1_content } from "./en-US.js"

export { academy_pages_cred_faq_row1_title } from "./en-US.js"

export { academy_pages_cred_faq_row2_content } from "./en-US.js"

export { academy_pages_cred_faq_row2_title } from "./en-US.js"

export { academy_pages_cred_faq_row3_content } from "./en-US.js"

export { academy_pages_cred_faq_row3_title } from "./en-US.js"

export { academy_pages_cred_faq_row4_content } from "./en-US.js"

export { academy_pages_cred_faq_row4_title } from "./en-US.js"

export { academy_pages_cred_faq_row5_content } from "./en-US.js"

export { academy_pages_cred_faq_row5_title } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_content_wallet_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_0 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_1 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_2 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_3 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_4 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_5 } from "./en-US.js"

export { academy_pages_cred_faq_row6_page_6 } from "./en-US.js"

export { academy_pages_cred_faq_row6_title } from "./en-US.js"

export { academy_pages_cred_faq_subhead } from "./en-US.js"

export { academy_pages_cred_landing_34 } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_collapse } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_button_text_expand } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_subtitle } from "./en-US.js"

export { academy_pages_cred_landing_cred_cards_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_body } from "./en-US.js"

export { academy_pages_cred_landing_cta2_card4_title } from "./en-US.js"

export { academy_pages_cred_landing_cta2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card1_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card2_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_body } from "./en-US.js"

export { academy_pages_cred_landing_cta_card3_title } from "./en-US.js"

export { academy_pages_cred_landing_cta_header } from "./en-US.js"

export { academy_pages_cred_landing_hero_headline } from "./en-US.js"

export { academy_pages_cred_landing_hero_subhead } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row1_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row2_headline } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_eyebrow } from "./en-US.js"

export { academy_pages_cred_testimonials_row3_headline } from "./en-US.js"

export { academy_partner_tag } from "./en-US.js"

export { academy_search_href } from "./en-US.js"

export { app_marketplace_details_built_by } from "./en-US.js"

export { app_marketplace_details_carousel_close } from "./en-US.js"

export { app_marketplace_details_carousel_image_alt } from "./en-US.js"

export { app_marketplace_details_carousel_next_image } from "./en-US.js"

export { app_marketplace_details_carousel_previous_image } from "./en-US.js"

export { app_marketplace_details_case_study } from "./en-US.js"

export { app_marketplace_details_category } from "./en-US.js"

export { app_marketplace_details_cover_image } from "./en-US.js"

export { app_marketplace_details_developer } from "./en-US.js"

export { app_marketplace_details_features } from "./en-US.js"

export { app_marketplace_details_guide } from "./en-US.js"

export { app_marketplace_details_install } from "./en-US.js"

export { app_marketplace_details_install_installs } from "./en-US.js"

export { app_marketplace_details_languages } from "./en-US.js"

export { app_marketplace_details_marketing_video } from "./en-US.js"

export { app_marketplace_details_overview } from "./en-US.js"

export { app_marketplace_details_pricing } from "./en-US.js"

export { app_marketplace_details_pricing_free } from "./en-US.js"

export { app_marketplace_details_pricing_learn_more } from "./en-US.js"

export { app_marketplace_details_similar_apps } from "./en-US.js"

export { app_marketplace_details_support } from "./en-US.js"

export { app_marketplace_details_support_help } from "./en-US.js"

export { app_marketplace_details_support_privacy } from "./en-US.js"

export { app_marketplace_details_support_website } from "./en-US.js"

export { app_marketplace_details_user_guide } from "./en-US.js"

export { app_marketplace_gallery_thumbnail } from "./en-US.js"

export { app_marketplace_gallery_thumbnail_alt } from "./en-US.js"

export { app_marketplace_install_alert_learn_more } from "./en-US.js"

export { app_marketplace_install_button } from "./en-US.js"

export { app_marketplace_install_status_invalid_permissions } from "./en-US.js"

export { app_marketplace_install_status_unhealthy } from "./en-US.js"

export { app_marketplace_install_status_uninstallable } from "./en-US.js"

export { app_marketplace_installed_button } from "./en-US.js"

export { app_marketplace_manage_button } from "./en-US.js"

export { app_marketplace_notFound_button_text } from "./en-US.js"

export { app_marketplace_preview_banner } from "./en-US.js"

export { developer_portal_get_started_card_one_description } from "./en-US.js"

export { developer_portal_get_started_card_one_title } from "./en-US.js"

export { developer_portal_get_started_card_three_description } from "./en-US.js"

export { developer_portal_get_started_card_three_title } from "./en-US.js"

export { developer_portal_get_started_card_two_description } from "./en-US.js"

export { developer_portal_get_started_card_two_title } from "./en-US.js"

export { developer_portal_get_started_header } from "./en-US.js"

export { developer_portal_need_more_help_card_one_description } from "./en-US.js"

export { developer_portal_need_more_help_card_one_title } from "./en-US.js"

export { developer_portal_need_more_help_card_two_description } from "./en-US.js"

export { developer_portal_need_more_help_card_two_title } from "./en-US.js"

export { developer_portal_need_more_help_header } from "./en-US.js"

export { developer_portal_use_cases_cta } from "./en-US.js"

export { developer_portal_use_cases_header } from "./en-US.js"

export { developer_portal_use_cases_tab_one_author } from "./en-US.js"

export { developer_portal_use_cases_tab_one_description } from "./en-US.js"

export { developer_portal_use_cases_tab_one_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_one_title } from "./en-US.js"

export { developer_portal_use_cases_tab_three_author } from "./en-US.js"

export { developer_portal_use_cases_tab_three_description } from "./en-US.js"

export { developer_portal_use_cases_tab_three_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_three_title } from "./en-US.js"

export { developer_portal_use_cases_tab_two_author } from "./en-US.js"

export { developer_portal_use_cases_tab_two_description } from "./en-US.js"

export { developer_portal_use_cases_tab_two_quote } from "./en-US.js"

export { developer_portal_use_cases_tab_two_title } from "./en-US.js"

export { molecules_blogCard_related_content } from "./en-US.js"

export { navigation_ecosystem_ctas_academy_profile_href } from "./en-US.js"

export { organisms_forms_fields_company_website_placeholder } from "./en-US.js"

export { organisms_forms_fields_firstname_placeholder } from "./en-US.js"

export { organisms_forms_fields_form_opt_in_label } from "./en-US.js"

export { organisms_forms_fields_lastname_placeholder } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_errors_required } from "./en-US.js"

export { organisms_forms_fields_list_size_from_website_form_placeholder } from "./en-US.js"

export { organisms_forms_fields_website_errors_required } from "./en-US.js"

export { organisms_forms_fields_website_placeholder } from "./en-US.js"

export { organisms_moreCards_card1_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card2_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_button_openInNewTab } from "./en-US.js"

export { organisms_moreCards_card3_richText_template } from "./en-US.js"

export { pages_b2ccrm_analytics_cta } from "./en-US.js"

export { pages_b2ccrm_analytics_eyebrow } from "./en-US.js"

export { pages_b2ccrm_analytics_headline } from "./en-US.js"

export { pages_b2ccrm_analytics_logo } from "./en-US.js"

export { pages_b2ccrm_analytics_p1 } from "./en-US.js"

export { pages_b2ccrm_analytics_p2 } from "./en-US.js"

export { pages_b2ccrm_analytics_p3 } from "./en-US.js"

export { pages_b2ccrm_analytics_quote } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_analytics_quote_title } from "./en-US.js"

export { pages_b2ccrm_description } from "./en-US.js"

export { pages_b2ccrm_hero_content_cta } from "./en-US.js"

export { pages_b2ccrm_hero_content_finally } from "./en-US.js"

export { pages_b2ccrm_hero_content_title } from "./en-US.js"

export { pages_b2ccrm_hero_rip_headline } from "./en-US.js"

export { pages_b2ccrm_hero_rip_instructions } from "./en-US.js"

export { pages_b2ccrm_introduction_eyebrow } from "./en-US.js"

export { pages_b2ccrm_introduction_headline } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill1_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill2_tag } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill3_copy } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4 } from "./en-US.js"

export { pages_b2ccrm_introduction_pill4_copy } from "./en-US.js"

export { pages_b2ccrm_marketing_cta } from "./en-US.js"

export { pages_b2ccrm_marketing_eyebrow } from "./en-US.js"

export { pages_b2ccrm_marketing_headline } from "./en-US.js"

export { pages_b2ccrm_marketing_logo } from "./en-US.js"

export { pages_b2ccrm_marketing_quote } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_marketing_quote_title } from "./en-US.js"

export { pages_b2ccrm_nav_analytics } from "./en-US.js"

export { pages_b2ccrm_nav_marketing } from "./en-US.js"

export { pages_b2ccrm_nav_platform } from "./en-US.js"

export { pages_b2ccrm_nav_quiz } from "./en-US.js"

export { pages_b2ccrm_nav_service } from "./en-US.js"

export { pages_b2ccrm_nav_the_b2c_crm } from "./en-US.js"

export { pages_b2ccrm_nav_watch_demo } from "./en-US.js"

export { pages_b2ccrm_platform_cta } from "./en-US.js"

export { pages_b2ccrm_platform_eyebrow } from "./en-US.js"

export { pages_b2ccrm_platform_headline } from "./en-US.js"

export { pages_b2ccrm_platform_logo } from "./en-US.js"

export { pages_b2ccrm_platform_p1 } from "./en-US.js"

export { pages_b2ccrm_platform_p2 } from "./en-US.js"

export { pages_b2ccrm_platform_p3 } from "./en-US.js"

export { pages_b2ccrm_platform_stat } from "./en-US.js"

export { pages_b2ccrm_platform_stat_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_cta } from "./en-US.js"

export { pages_b2ccrm_quiz_eyebrow } from "./en-US.js"

export { pages_b2ccrm_quiz_headline } from "./en-US.js"

export { pages_b2ccrm_quiz_subtext } from "./en-US.js"

export { pages_b2ccrm_service_cta } from "./en-US.js"

export { pages_b2ccrm_service_eyebrow } from "./en-US.js"

export { pages_b2ccrm_service_headline } from "./en-US.js"

export { pages_b2ccrm_service_logo } from "./en-US.js"

export { pages_b2ccrm_service_p2 } from "./en-US.js"

export { pages_b2ccrm_service_p3 } from "./en-US.js"

export { pages_b2ccrm_service_quote } from "./en-US.js"

export { pages_b2ccrm_service_quote_attribution } from "./en-US.js"

export { pages_b2ccrm_service_quote_title } from "./en-US.js"

export { pages_b2ccrm_title } from "./en-US.js"

export { organisms_whatsNew_refinements_cdp } from "./en-US.js"

export { academy_courseStatus_registed } from "./en-US.js"

export { helpCenter_templates_search_results } from "./en-US.js"

export { organisms_forms_legal_agreeTermsLinkText } from "./en-US.js"

export { organisms_forms_legal_agreeToPartnerCodeOfConduct } from "./en-US.js"

export { organisms_forms_legal_agreeToTermsOfService } from "./en-US.js"

export { organisms_forms_legal_codeOfConduct_href } from "./en-US.js"

export { organisms_forms_legal_marketingCommunicationsConsent } from "./en-US.js"

export { organisms_pricing_plans_advance_data_platform_subTextInfoHeader } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_buttons_getDemo } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_headline } from "./en-US.js"

export { organisms_pricing_plans_maxContacts_richTextBody } from "./en-US.js"

/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organisms_pricing_calculator_locales_BR = () => `스페인`
